import React from 'react';

import { Container } from './styles';

const ButtonDefault = ({ children, icon: Icon, ...rest }) => {
  return (
    <Container>
      <button type="button" {...rest}>
        {Icon && <Icon size={16} />}
        {children}
      </button>
    </Container>
  );
};

export default ButtonDefault;
